import { useEffect, useState } from "react";
import CheckboxCell from "../../common/interactive/CheckboxCell";
import { objectHasOwnProperty } from "../../../lib/script";
import { useSelector } from "react-redux";

export default function ExceptionsGroupItem({filter, exceptionValues, selectCheckBoxHandler, workQ, countHandler}) {
    const selectedExceptions = useSelector(state => state.filter.exceptions)

    const [isItemChecked, setIsItemChecked] = useState(exceptionValues?.case_flags ? exceptionValues?.case_flags[filter.key] : false)
    // const [isItemChecked, setIsItemChecked] = useState(exceptionValues?.case_flags ? exceptionValues?.case_flags[filter.key] : false)

    // useEffect(() => {
    //     if (workQ && workQ.exceptions_filters) {

    //         if (!objectHasOwnProperty(exceptionValues?.case_flags, filter.key)) {
    //             if (workQ.exceptions_filters[filter?.key]) {
    //                 setIsItemChecked(true)
    //             } 
    //         }
    //     }

    //     if (exceptionValues && exceptionValues.case_flags && objectHasOwnProperty(exceptionValues.case_flags, filter.key)) {
    //         setIsItemChecked(exceptionValues.case_flags[filter.key])
    //     }

    // }, [workQ, filter, exceptionValues])

        useEffect(() => {          

            if (exceptionValues && exceptionValues.case_flags && objectHasOwnProperty(exceptionValues.case_flags, filter.key)) {
                setIsItemChecked(exceptionValues.case_flags[filter.key])
            }

        }, [workQ, filter, exceptionValues])
    return <CheckboxCell label={filter.label} checked={isItemChecked} direction={'reverse'} action={selectCheckBoxHandler} identifier={{type: filter.key}}/>
}